module.exports = "div.unknown-agent-link,div.unknown-agent-link::before,div.new-agent-link,div.new-agent-link::before{color:#a4343a}\n"